export default __webpack_public_path__ + "assets/fonts/a676a80f36a44bec1d618eafbe247b15.ttf";